var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card-item checkin-content" }, [
      _c(
        "div",
        {
          staticClass: "card-content columns is-multiline",
          attrs: { id: "checkin-welcome" },
        },
        [
          _c("div", { staticClass: "text-content column has-text-centered" }, [
            _c("img", {
              staticClass: "thanks-image",
              attrs: {
                src: require("../../../assets/img/checkin_gracias.svg"),
              },
            }),
            _c("h3", [
              _vm._v(
                " ¡Gracias " +
                  _vm._s(
                    _vm.$store.state.currentUser &&
                      _vm.$store.state.currentUser.user
                      ? _vm.$store.state.currentUser.user.name
                      : ""
                  ) +
                  "! "
              ),
            ]),
            _c("p", [
              _vm._v(
                "Ya puedes ver y gestionar todo lo relacionado a tu crédito."
              ),
            ]),
            _c("p", [
              _vm._v("Felicidades por cumplir tu meta del hogar propio!"),
            ]),
            _c("div", { staticClass: "has-text-centered" }, [
              _c(
                "div",
                { staticClass: "button-content transition-slow complete" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "button is-button-primary is-rounded",
                      attrs: { id: "continueButton" },
                      on: {
                        click: function ($event) {
                          return _vm.checkIn()
                        },
                      },
                    },
                    [_vm._v(" Ir a mis créditos ")]
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }